import Link from 'next/link'
import Image from 'next/image'
import { CheckIcon } from '@heroicons/react/24/solid'
import StatusPill from '@/components/common/StatusPill'
import { className } from '@/components/common/styles'

const Icon = ({ ...props }) => {
  return (
    //
    <div className="w-14 h-14 text-yellow-500 items-center mx-4">
      <Image
        alt="logo"
        width={10}
        height={10}
        className={`${props.className} w-full h-auto`}
        src={props.src as string}
      />
    </div>
  )
}

type Feature = {
  id: number
  title: string
  isActive?: boolean
  tag?: {
    label: string
    type: string
  }
}

type PricingDefaultCardType = {
  pricing: {
    id: number
    title: string
    icon: string
    subTitle: string
    price: number | string
    buttonText?: string
    isFeatured?: boolean
    featureTitle?: string
    features?: Array<Feature>
  }
}

const PricingDefaultCard = ({
  pricing: {
    title,
    icon,
    subTitle,
    price,
    buttonText,
    isFeatured,
    featureTitle,
    features,
  },
}: PricingDefaultCardType) => {
  return (
    <div className="h-fit">
      <div
        className={`${
          isFeatured ? 'text-center rounded-t-lg bg-violet-600 text-white' : ''
        } text-sm py-1`}
      >
        {isFeatured && <span>Most popular</span>}&nbsp;
      </div>
      <div
        className={`${
          isFeatured
            ? 'border-violet-600 rounded-b-md bg-violet-600'
            : 'border-gray-100 dark:border-gray-800 rounded-md bg-gray-100 dark:bg-gray-800'
        } border-4 md:col-span-1 h-full`}
      >
        <div className="p-4 border-4 rounded-md border-gray-100 dark:border-gray-800 bg-gray-100 dark:bg-gray-800">
          <div className="text-center">
            <div className="text-2xl my-0 flex items-center justify-center">
              <h3>{title}</h3>
              <Icon className="rtl:-scale-x-100" src={icon} />
            </div>
            <div className="mt-3 sm:h-12 md:h-32 lg:h-20 xl:h-16 grid place-items-center">
              {subTitle}
              <div className="w-full h-1 bg-red-100 sm:bg-red-200 md:bg-red-400 lg:bg-red-600 xl:bg-red-800" />
            </div>
            <div className="my-4">
              <div className="font-bold">USD $ {price} / year</div>
            </div>
            <div className="grid place-items-center">
              <button
                type="button"
                className={className}
                onClick={() => console.log(`${buttonText ?? 'none'} clicked`)}
              >
                {buttonText}
              </button>
            </div>
          </div>
          <hr className="border border-dashed my-4 border-gray-200 dark:border-gray-700" />
          <div className="w-full h-0.5" />
          <div className="text-start px-sm-4 py-4">
            <div className="text-base">{featureTitle}</div>
            <ul className="list-unstyled mt-3 mb-4">
              {features?.map((feature) => (
                <li className="py-1 flex" key={feature.id}>
                  <CheckIcon className="text-green-500 h-5 w-5 mt-0 mx-1" />
                  {feature.title}
                  {feature.tag && (
                    <StatusPill
                      className="bg-black dark:bg-white text-white dark:text-black mx-2"
                      value={feature.tag.label}
                    />
                  )}
                </li>
              ))}
            </ul>
            <hr className="border border-dashed my-4 border-gray-200 dark:border-gray-700" />
            <div className="pt-4 pb-4">
              <Link href="#!">
                <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                  Read more about {title}
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingDefaultCard
